import { MapPin } from 'lucide-react';
import PartnerActionsMenu from '../PartnerActionsMenu/PartnerActionsMenu';

const PartnerRow = ({ partner, index, onView, onEdit, onFreeze, onDelete }) => {
  return (
    <div className="flex items-center justify-between py-1 group hover:bg-slate-50/80 transition-all duration-200">
      {/* Sr no. */}
      <div className="w-16 sm:w-20 px-6 py-3.5 text-sm text-slate-400 font-normal whitespace-nowrap">
        {index + 1}
      </div>

      {/* Partner Info */}
      <div className="flex-1 min-w-[180px] px-6 py-3.5">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-emerald-50 text-[#067978] flex items-center justify-center overflow-hidden font-normal text-sm flex-shrink-0">
            {partner.logo_url ? (
              <img src={partner.logo_url} alt="Logo" className="w-full h-full object-cover" />
            ) : (
              (partner.business_name || '?').charAt(0).toUpperCase()
            )}
          </div>
          <div className="min-w-0 truncate">
            <div
              className="font-normal text-slate-800 text-sm hover:text-[#067978] transition-colors truncate cursor-pointer"
              title={partner.business_name}
              onClick={() => onView && onView(partner)}
            >
              {partner.business_name}
            </div>
            {partner.city && (
              <div className="flex items-center gap-1 text-xs text-slate-400 font-normal mt-0.5 truncate">
                <MapPin size={10} className="text-[#067978] flex-shrink-0" />
                <span>{partner.city}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Type / Category */}
      <div className="w-32 sm:w-36 px-6 py-3.5">
        <span className="px-2.5 py-0.5 text-xs font-medium rounded-full capitalize inline-block bg-teal-50 text-[#067978] border border-teal-100/70">
          {partner.category
            ? partner.category.charAt(0).toUpperCase() + partner.category.slice(1).toLowerCase()
            : 'Shop'}
        </span>
      </div>

      {/* Phone Number */}
      <div className="w-36 sm:w-44 px-6 py-3.5 text-sm font-normal text-slate-700 font-mono truncate">
        {partner.phone_number || 'N/A'}
      </div>

      {/* Status */}
      <div className="w-28 sm:w-32 px-6 py-3.5 flex justify-center">
        {partner.isActive !== false ? (
          <span className="inline-flex items-center gap-1.5 text-sm font-normal text-emerald-600">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
            Active
          </span>
        ) : (
          <span className="inline-flex items-center gap-1.5 text-sm font-normal text-rose-500">
            <span className="w-1.5 h-1.5 rounded-full bg-rose-500"></span>
            Frozen
          </span>
        )}
      </div>

      {/* Actions */}
      <div className="w-28 sm:w-32 px-4 py-3.5 flex items-center justify-center relative">
        <PartnerActionsMenu
          partner={partner}
          onView={onView}
          onEdit={onEdit}
          onFreeze={onFreeze}
          onDelete={onDelete}
        />
      </div>
    </div>
  );
};

export default PartnerRow;
